export function statusCodeToText (code) {
  if (code) {
    let map = {
      1: '待付款', 2: '待发货', 3: '待收货', 4: '已完成', 5: '已取消'
    }
    return map[code]
  }
  console.warn('status code wrong:', code)
  return ''
}
